<style lang="less" scoped>
@import '../../../style/common/variable';
.zlkList{position: relative;width: 100%;display: flex;flex-direction: column;font-family: AlibabaPuHuiTi-Medium;}
.first{display: flex;flex-direction: column;width: 810px;margin-right: 40px;margin-bottom: 25px;}
ul{list-style: none;margin: 0px;margin-left:-40px;margin-top: 0px;}
.imgTitleContent{text-align: left;}
.el-button{width: 800px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);}
@media screen and (max-width: @max-screen) {
  .el-button{width: 94vw;margin-left: 3vw}
}
</style>

<template>
  <div class="zlkList">
    <div class="first">
      <ul>
        <li v-for="(item,index) in imgTitleContentdata" :key="index" >
          <ImgTitleContent class="imgTitleContent" :imgTitleContentItem="item" @handleClick="goDetails"></ImgTitleContent>
        </li>
      </ul>
    </div>
    <el-button @click="getOthers">加载更多</el-button>
  </div>
</template>

<script>
/**
 * 何宽 资料库列表页面
 */
import ImgTitleContent from '../assembly/ImgTitleContent.vue'
export default {
  components: {
    ImgTitleContent
  },
  name: '',
  data()
  {
    return {
      categorydata: [], // 分类浏览数据
      imgTitleContentdata: [], //列表页数据
      catid: null,
      currentPage: 1
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.catid = +nval.query.catid
        this.getdata()
      },
      immediate: true
    }
  },
  methods: {
    getdata()
    {
      //获取列表数据
      let paras = {cmd: 'query', _major: 11, _minor: 24, _exp: `catid=${this.catid} and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        ret[0].data.forEach(item =>
        {
          this.imgTitleContentdata.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, introduce: item.introduce, release: '发布时间', time: item.addtime, description: '关键词', value: item.keyword})
        })
      })
    },
    // 点击加载更多，依次添加10条数据，并重新渲染然页面展示的数据
    getOthers()
    {
      this.currentPage++
      this.getdata()
    },
    // 跳转到资料库详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZlkList.vue